// extracted by mini-css-extract-plugin
module.exports = {"body":"Slides_body__2rqst"};